import ProductPage from "../../components/ProductPage";
import { lifeInsuranceData } from "../../data/productsData";
export default function LifeInsurance() { return <ProductPage data={lifeInsuranceData} />; }